import { useState, useEffect } from "react";
import TableTop from "../TableComponents/TableTop";
import { Table, TableBody, TablePagination } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import MessagesInRequestTableHead from "../TableHeads/MessagesInRequestTableHead";
import MessagesInRequestTableRow from "../TableRows/MessagesInRequestTableRow";
import { getOtherMessages } from "../../../reduxStore/entities/messages";
import { requestGetSellerOtherMessages } from "../../../reduxStore/sagas/requests/messages";

const MessagesInOtherRequestsTable = () => {

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(15);

    const filterDto = {
        limit: rowsPerPage,
        offset: page * rowsPerPage,
    };

    const [filter, setFilter] = useState(filterDto);
    const [isTableShown, setIsTableShown] = useState(true);
    const [messagesData, setMessagesData] = useState(null);

     useEffect(() => {
        setFilter(filterDto);
    }, [page, rowsPerPage]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await requestGetSellerOtherMessages(filter);
                if (response) {
                    setMessagesData(response.data);
                }
            } catch (error) {
                console.error("Failed to fetch messages:", error);
            }
        };

        fetchData();
    }, [filter]);

    if (!messagesData) {
        return null;
    }
    const handleChangePage = (_event, newPage) => {
    setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    const count = messagesData.count;    


    return (
        <div style={styles.mainContainer}>
            <TableTop
                title={"Ostale poruke"}
                count={count}
                open={isTableShown}
                setOpen={setIsTableShown}
            />

            {isTableShown && (
                <div style={styles.tablePaddingDiv}>
                    <div style={styles.tableBorderDiv}>
                        <Table>
                            <MessagesInRequestTableHead />

                            <TableBody>

                                {messagesData.rows.map((row, index) => (
                                    <MessagesInRequestTableRow
                                        key={index}
                                        partOffer={row}
                                    />
                                ))}

                            </TableBody>

                        </Table>
                        <TablePagination rowsPerPageOptions={
                            [15, 25, 50]}
                            component="div"
                            count={count}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={(event, newPage) => {
                                handleChangePage(event, newPage, setPage)
                            }}
                            onRowsPerPageChange={(event) => {
                                handleChangeRowsPerPage(
                                    event,
                                    setRowsPerPage,
                                    setPage
                                )
                            }}
                        />
                    </div>
                </div>
            )}

        </div>
    );
};


export default MessagesInOtherRequestsTable;

const styles = {
    mainContainer: {

    },
    tablePaddingDiv: {
        paddingInline: 30,
    },
    tableBorderDiv: {
        borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
        borderRight: "1px solid rgba(0, 0, 0, 0.12)"
    }
};